define(["mw-log/util/LogUtils"], function (LogUtils) {

    function createBacklog(size) {
        var backlog = {};
        var messages = [];
        LogUtils.makeReadOnlyProperty(backlog, "size", size);
        var index = 0;

        backlog.add = function (message) {
            messages[index] = message;
            index = (index + 1) % backlog.size;
        };

        backlog.applyCallback = function (callback) {
            var start = index + 1;
            if (messages[start] === undefined) {
                start = 0;
            }

            var count = 0,
                i = start;
            while (count < backlog.size && messages[i] !== undefined) {
                callback(messages[i]);
                i = (i + 1) % size;
                count++;
            }
        };

        return backlog;
    }

    var backlogMaker = {};
    backlogMaker.create = createBacklog;

    return backlogMaker;
});
//# sourceMappingURL=Backlog.js.map
